// src/i18n.js

export const translations = {
    // INGLESE - Lingua DEFAULT
    en: {
        // Overlay Mobile
        mainTitle: "DEXTER'S HOUSE",
        mainDescription: "Start to discover all his victims!",
        mobileFooterInfo: "You are viewing the site from a smartphone.<br/>Some features are disabled in this mode.<br/>For the full experience, view the site from a computer.",
        btnStart: "START",
        
        // Overlay Desktop
        controlsTitle: "CONTROLS",
        controlsArrowUpDown: "ARROWS &nbsp; <span class=\"instruction-graph\">↑</span> &nbsp; <span class=\"instruction-graph\">↓</span> - Forward / Backward",
        controlsArrowLeftRight: "ARROWS &nbsp; <span class=\"instruction-graph\">←</span> &nbsp; <span class=\"instruction-graph\">→</span> - Rotate left / right",
        controlsShift: "SHIFT - Go up",
        controlsCtrl: "CTRL - Go down",
        controlsMouse: "MOVE MOUSE &nbsp; - Rotate view in all directions",
        footerEsc: "Press ESC to exit exploration",
        footerEnter: "Press <span class=\"bordered\">↵ ENTER</span> to start",
        
        // Tombe
        season: "Season"
    },
    
    // ITALIANO - Solo per utenti italiani
    it: {
        // Overlay Mobile
        mainTitle: "CASA DI DEXTER",
        mainDescription: "Inizia per scoprire tutte le sue vittime!",
        mobileFooterInfo: "Stai visualizzando il sito da smartphone.<br/>In questa modalità alcune funzionalità sono disabilitate.<br/>Per una esperienza completa visualizza il sito da computer.",
        btnStart: "INIZIA",
        
        // Overlay Desktop
        controlsTitle: "CONTROLLI",
        controlsArrowUpDown: "FRECCE &nbsp; <span class=\"instruction-graph\">↑</span> &nbsp; <span class=\"instruction-graph\">↓</span> - Avanti / Indietro",
        controlsArrowLeftRight: "FRECCE &nbsp; <span class=\"instruction-graph\">←</span> &nbsp; <span class=\"instruction-graph\">→</span> - Ruota sinistra / destra",
        controlsShift: "SHIFT - Sali",
        controlsCtrl: "CTRL - Scendi",
        controlsMouse: "MUOVI MOUSE &nbsp; - Ruota la visuale in tutte le direzioni",
        footerEsc: "Premi ESC per uscire dall'esplorazione",
        footerEnter: "Premi <span class=\"bordered\">↵ INVIO</span> per iniziare",
        
        // Tombe
        season: "Stagione"
    }
}

// Funzione per ottenere la lingua dell'utente
export const getUserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage
    // Solo se la lingua inizia con 'it' (it-IT, it-CH, ecc.) → Italiano
    // Tutti gli altri → Inglese (default)
    return browserLang.toLowerCase().startsWith('it') ? 'it' : 'en'
}

// Helper per ottenere il testo tradotto
export const t = (key, lang = 'en') => {
    return translations[lang]?.[key] || translations['en'][key]
}
